
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon-svg icon-time",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16","fill":"var(--iconColor, --current-color-500)"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M8.001 0C6.887 0 5.846.21 4.88.63a7.788 7.788 0 00-2.55 1.704 8.234 8.234 0 00-1.715 2.54A7.984 7.984 0 000 7.99c0 1.114.205 2.153.614 3.119.421.977.993 1.826 1.715 2.547a8.086 8.086 0 002.55 1.713c.967.42 2.008.63 3.122.63 1.115 0 2.156-.21 3.123-.63a8.086 8.086 0 002.55-1.713 8.075 8.075 0 001.715-2.547c.41-.966.614-2.005.614-3.119a7.984 7.984 0 00-.614-3.118 8.234 8.234 0 00-1.715-2.539A7.788 7.788 0 0011.124.63 7.745 7.745 0 008 0zM8 14.5c-.903 0-1.75-.17-2.54-.508a6.522 6.522 0 01-2.064-1.388 6.522 6.522 0 01-1.388-2.065A6.377 6.377 0 011.5 8c0-.903.17-1.75.508-2.54a6.522 6.522 0 011.388-2.064A6.522 6.522 0 015.46 2.008 6.377 6.377 0 018 1.5c.903 0 1.75.17 2.54.508.789.338 1.477.801 2.064 1.388a6.522 6.522 0 011.388 2.065c.339.79.508 1.636.508 2.539 0 .903-.17 1.75-.508 2.54a6.522 6.522 0 01-1.388 2.064 6.522 6.522 0 01-2.065 1.388A6.377 6.377 0 018 14.5zm.735-6.789V3.634a.687.687 0 00-.205-.52.733.733 0 00-.529-.197.733.733 0 00-.528.197.687.687 0 00-.205.52V8c0 .114.02.21.06.29.04.08.093.154.162.222l2.183 2.184c.08.08.168.137.265.17.097.035.179.052.247.052a.766.766 0 00.512-.222.703.703 0 000-1.024L8.735 7.711z"}})])
          )
        }
      }
    